import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { useSite } from "@/context/SiteContext";
import { LeadForm } from "@/components/site/LeadForm";

export function JoinDialog() {
  const { join, closeJoin } = useSite();
  return (
    <Dialog open={join.open} onOpenChange={(o) => !o && closeJoin()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto border-[rgba(212,175,55,0.25)] bg-[#0F0F0F] sm:max-w-lg" data-testid="join-dialog">
        <p className="eyebrow">No payment online</p>
        <DialogTitle className="h-display text-4xl text-white">Start at Iron Pump</DialogTitle>
        <DialogDescription className="text-sm text-white/60">
          Tell us a bit about you. Our team will reach out and get you set up at the front desk.
        </DialogDescription>
        <LeadForm key={`${join.type}-${join.plan}-${join.open}`} defaultType={join.type} defaultPlan={join.plan} allowTypeSwitch idPrefix="join" />
      </DialogContent>
    </Dialog>
  );
}
